import { createStyles, makeStyles } from '@mui/styles';
import { STYLE } from '../../../../constants';

export const useStyles = makeStyles((theme: any) =>
  createStyles({
    formControl: {
      '& .MuiFormControlLabel-root': {
        margin: 0,
      },
      '& .MuiFormLabel-root': {
        fontSize: '14px',
        fontWeight: 500,
        lineHeight: '20px',
        margin: '0 0 12px 0',
        color: STYLE.COLOR.TEXT2,
      },
      '& .MuiFormControlLabel-label': {
        color: `${STYLE.COLOR.TEXT1} !important`,
      },
      '& .MuiFormControlLabel-root.Mui-disabled': {
        opacity: 0.5,
        cursor: 'not-allowed',
      },
      '& .MuiRadio-root': {
        padding: '0px 10px 0px 0px !important',
      },
    },
    radio: {},
    radioLabelRow: {
      padding: '0px 20px 0px 0px',
    },
    requiredMark: {
      color: STYLE.COLOR.ERROR,
      paddingLeft: '3px',
    },
    skippableMark: {
      color: STYLE.COLOR.WARNING,
      paddingLeft: '3px',
    },
  }),
);
